import React, {useState} from 'react';
import dayjs from "dayjs";
import FilterInput from "../FilterInput";
import FilterSelect from "../FilterSelect";
import FilterDate from "../FiltersDateFromTo/FilterDate";
import FieldCheckbox from "../FieldCheckbox";
import ButtonExportToExcel from "../../../modules/Inspection/components/ButtonExportToExcel";
import {limitIntegerValueLength} from "../../utils/form/limitValueLength";
import {generateExcelFile} from "../../../modules/Inspection/utils/exportToExcel";
import styles from './styles.module.scss';

const TableFilters = ({
                        module,
                        search: {
                          city,
                          street,
                          gush,
                          helka,
                          fromDate,
                          toDate,
                          customerName,
                          shumaID,
                          shumaTypeID,
                          propertyTypeID,
                          statusTypeID,
                          fromRoomCount,
                          toRoomCount,
                          fromRegisteredArea,
                          toRegisteredArea,
                          elevator,
                          responsibleUserID,
                          taskStatusID,
                          taskTypeID,
                          fromDueDate,
                          toDueDate,
                        },
                        options,
                        allowSearchByCustomerName,
                        allowSearchByShumaID,
                        preparedDataForExcel,
                        headersForExcel,
                        excelFileName,
                        getListForExcel
                      }) => {
  const [showMore, setShowMore] = useState(false);
  const handleExportToExcel = async () => {
    await getListForExcel();
    generateExcelFile([{data: preparedDataForExcel, title: headersForExcel}], excelFileName)
  };

  const getFilters = () => {
    switch (module) {
      case 'InspectedList':
        return (
          <>
            <div className={styles.commonFiltersContainer}>
              <FilterSelect
                placeholder="יישוב"
                filter={city}
                options={options.cities}
              />
              <FilterInput
                placeholder="גוש"
                value={gush.value}
                onChange={event => gush.onChange(event.target.value)}
              />
              <FilterInput
                placeholder="חלקה"
                value={helka.value}
                onChange={event => helka.onChange(event.target.value)}
              />
              <FilterInput
                placeholder="מספר דוח"
                value={shumaID.value}
                onChange={event => shumaID.onChange(limitIntegerValueLength(9999)(event))}
              />
              <FilterSelect
                placeholder="סוג הדוח"
                filter={shumaTypeID}
                options={options.shumaTypes}
              />
              <FilterSelect
                placeholder="סוג הנכס"
                filter={propertyTypeID}
                options={options.propertyTypes}
              />
            </div>
            <FieldCheckbox
              fieldId={'showAdvanced'}
              variant={'slider'}
              label={'סינון מתקדם'}
              onChange={() => setShowMore(!showMore)}
              containerStyles={styles.sliderMargins}
            />
            {showMore && (
              <div className={styles.advancedFiltersContainer}>
                <FilterSelect
                  placeholder="רחוב"
                  filter={street}
                  options={options.streets}
                  disabled={!city.value}
                />
                <FilterDate
                  placeholder={'מתאריך יצירה'}
                  filter={fromDate}
                  maxDate={dayjs(toDate.value)}
                />
                <FilterDate
                  placeholder={'עד תאריך יצירה'}
                  filter={toDate}
                  minDate={dayjs(fromDate.value)}
                />
                <FilterSelect
                  placeholder="סטטוס"
                  filter={statusTypeID}
                  options={options.shumaStatuses}
                />
                <FilterSelect
                  placeholder="מעלית"
                  filter={elevator}
                  options={options.elevatorPresence}
                />
                <FilterInput
                  placeholder="ממספר חדרים"
                  value={fromRoomCount.value}
                  onChange={event => fromRoomCount.onChange(event.target.value)}
                />
                <FilterInput
                  placeholder="עד מספר חדרים"
                  value={toRoomCount.value}
                  onChange={event => toRoomCount.onChange(event.target.value)}
                />
                <FilterInput
                  placeholder="משטח רשום"
                  value={fromRegisteredArea.value}
                  onChange={event => fromRegisteredArea.onChange(event.target.value)}
                />
                <FilterInput
                  placeholder="עד שטח רשום"
                  value={toRegisteredArea.value}
                  onChange={event => toRegisteredArea.onChange(event.target.value)}
                />
                <FilterInput
                  placeholder="לקוח"
                  value={customerName.value}
                  onChange={event => customerName.onChange(event.target.value)}
                />
              </div>
            )}
          </>
        )
      case 'InspectedFirmList':
        return (
          <>
            <div className={styles.commonFiltersContainer}>
              <FilterSelect
                placeholder="יישוב"
                filter={city}
                options={options.cities}
              />
              <FilterInput
                placeholder="גוש"
                value={gush.value}
                onChange={event => gush.onChange(event.target.value)}
              />
              <FilterInput
                placeholder="חלקה"
                value={helka.value}
                onChange={event => helka.onChange(event.target.value)}
              />
              <FilterInput
                placeholder="מספר דוח"
                value={shumaID.value}
                onChange={event => shumaID.onChange(limitIntegerValueLength(9999)(event))}
              />
              <FilterSelect
                placeholder="סוג הדוח"
                filter={shumaTypeID}
                options={options.shumaTypes}
              />
              <FilterSelect
                placeholder="סוג הנכס"
                filter={propertyTypeID}
                options={options.propertyTypes}
              />
            </div>
            {responsibleUserID && (
              <FilterSelect
                placeholder="גורם מטפל"
                filter={responsibleUserID}
                options={options.users}
                containerStyles={styles.responsibleUserContainer}
              />
            )}
            <FieldCheckbox
              fieldId={'showAdvanced'}
              variant={'slider'}
              label={'סינון מתקדם'}
              onChange={() => setShowMore(!showMore)}
              containerStyles={styles.sliderMargins}
            />
            {showMore && (
              <div className={styles.advancedFiltersContainer}>
                <FilterSelect
                  placeholder="רחוב"
                  filter={street}
                  options={options.streets}
                  disabled={!city.value}
                />
                <FilterDate
                  placeholder={'מתאריך יצירה'}
                  filter={fromDate}
                  maxDate={dayjs(toDate.value)}
                />
                <FilterDate
                  placeholder={'עד תאריך יצירה'}
                  filter={toDate}
                  minDate={dayjs(fromDate.value)}
                />
                <FilterSelect
                  placeholder="סטטוס"
                  filter={statusTypeID}
                  options={options.shumaStatuses}
                />
                <FilterSelect
                  placeholder="מעלית"
                  filter={elevator}
                  options={options.elevatorPresence}
                />
                <FilterInput
                  placeholder="ממספר חדרים"
                  value={fromRoomCount.value}
                  onChange={event => fromRoomCount.onChange(event.target.value)}
                />
                <FilterInput
                  placeholder="עד מספר חדרים"
                  value={toRoomCount.value}
                  onChange={event => toRoomCount.onChange(event.target.value)}
                />
                <FilterInput
                  placeholder="משטח רשום"
                  value={fromRegisteredArea.value}
                  onChange={event => fromRegisteredArea.onChange(event.target.value)}
                />
                <FilterInput
                  placeholder="עד שטח רשום"
                  value={toRegisteredArea.value}
                  onChange={event => toRegisteredArea.onChange(event.target.value)}
                />
                <FilterInput
                  placeholder="לקוח"
                  value={customerName.value}
                  onChange={event => customerName.onChange(event.target.value)}
                />
              </div>
            )}
          </>
        )
      case 'TasksList':
        return (
          <div className={styles.tasksFiltersContainer}>
            <div className={styles.tasksCommonFiltersContainer}>
              <FilterSelect
                placeholder="סוג משימה"
                filter={taskTypeID}
                options={options.taskTypes}
              />
              <FilterSelect
                placeholder="סטטוס"
                filter={taskStatusID}
                options={options.taskStatuses}
              />
              <FilterSelect
                placeholder="יישוב"
                filter={city}
                options={options.cities}
              />
              <FilterSelect
                placeholder="סוג הנכס"
                filter={propertyTypeID}
                options={options.propertyTypes}
              />
            </div>
            <FieldCheckbox
              fieldId={'showAdvanced'}
              variant={'slider'}
              label={'סינון מתקדם'}
              onChange={() => setShowMore(!showMore)}
              containerStyles={styles.sliderMargins}
            />
            {showMore && (
              <div className={styles.tasksAdvancedFiltersContainer}>
                <FilterDate
                  placeholder={'מתאריך לביצוע'}
                  filter={fromDueDate}
                  maxDate={dayjs(toDueDate.value) || dayjs().add(10, 'year')}
                  datepickerStyles={styles.taskDatepickers}
                />
                <FilterDate
                  placeholder={'עד תאריך לביצוע'}
                  filter={toDueDate}
                  maxDate={dayjs().add(10, 'year')}
                  minDate={dayjs(fromDueDate.value)}
                  datepickerStyles={styles.taskDatepickers}
                />
                <FilterInput
                  placeholder="לקוח"
                  value={customerName.value}
                  onChange={event => customerName.onChange(event.target.value)}
                />
              </div>
            )}
          </div>
        )
      case 'InspectedDatabase':
        return (
          <div className={styles.inspectedDatabaseContainer}>
            <FilterSelect
              placeholder="עיר"
              filter={city}
              options={options.cities}
            />
            <FilterSelect
              placeholder="רחוב"
              filter={street}
              options={options.streets}
            />
            <FilterInput
              placeholder="גוש"
              value={gush.value}
              onChange={event => gush.onChange(event.target.value)}
            />
            <FilterInput
              placeholder="חלקה"
              value={helka.value}
              onChange={event => helka.onChange(event.target.value)}
            />
            <FilterDate
              placeholder={'מתאריך'}
              filter={fromDate}
              maxDate={dayjs(toDate.value)}
            />
            <FilterDate
              placeholder={'מתאריך'}
              filter={toDate}
              minDate={dayjs(fromDate.value)}
            />
          </div>
        )
      default:
        return (
          <div>
            <div className={styles.twoInRow}>
              <FilterSelect
                placeholder="עיר"
                filter={city}
                options={options.cities}
              />
              <FilterSelect
                placeholder="רחוב"
                filter={street}
                options={options.streets}
              />
            </div>
            <div className={styles.twoInRow}>
              <FilterInput
                placeholder="גוש"
                value={gush.value}
                onChange={event => gush.onChange(event.target.value)}
              />
              <FilterInput
                placeholder="חלקה"
                value={helka.value}
                onChange={event => helka.onChange(event.target.value)}
              />
            </div>
            <div className={styles.twoInRow}>
              <FilterDate
                placeholder={'מתאריך'}
                filter={fromDate}
                maxDate={dayjs(toDate.value)}
              />
              <FilterDate
                placeholder={'מתאריך'}
                filter={toDate}
                minDate={dayjs(fromDate.value)}
              />
            </div>
            <div className={styles.twoInRow}>
              {allowSearchByCustomerName &&
                <FilterInput
                  placeholder="שם לקוח"
                  value={customerName.value}
                  onChange={event => customerName.onChange(event.target.value)}
                />
              }
              {allowSearchByShumaID &&
                <FilterInput
                  placeholder={`מספר דו"ח`}
                  value={shumaID.value}
                  onChange={event => shumaID.onChange(limitIntegerValueLength(9999)(event))}
                />
              }
            </div>
            {Boolean(excelFileName) &&
              <div className={styles.exportToExcelButtonContainer}>
                <ButtonExportToExcel onClick={handleExportToExcel}/>
              </div>
            }
          </div>
        )
    }
  };

  return (
    <div className={styles.filtersContainer}>
      {getFilters()}
    </div>
  );
};

export default TableFilters;
